import { gql } from '@apollo/client';
const SET_ORDER_SPECIFICATION_MANUFACTURER = gql `
  mutation SetOrderSpecificationManufacturer(
    $orderId: ID!
    $specificationId: ID!
    $manufacturerId: ID
  ) {
    setOrderSpecificationManufacturer(
      orderId: $orderId
      specificationId: $specificationId
      manufacturerId: $manufacturerId
    ) {
      specification {
        id
        itemCode
        fancyName
        description
      }
      productionApproved
      productionStartDate
      virtualProductionEndDate
      sumOfModelQuantities
      totalProductionTimeMinutes
      priority
      manufacturer {
        id
        shortName
        fullName
        employeesCount
        picture
        nonWorkingDays {
          id
          startDate
          endDate
        }
      }
      manufacturerOccupiedDates
    }
  }
`;
export default SET_ORDER_SPECIFICATION_MANUFACTURER;
